/* eslint-disable no-console */
// Get the total width of tabnav w/ labels on a single line
// If width is greater than window.innerWidth - margins/padding
// Convert nav to a dropdown
// Events should work the same
// Vice versa
// Allow for multiple instances of .tabnav on a page
const initTabnav = (wrapper) => {
  const dropdownBtn = wrapper.querySelector('.dropdown-btn');
  const nav = wrapper.querySelector('.tabnav');
  const tablist = wrapper.querySelector('.tabnav ul');
  const btnHeight = 50;

  const isDropdownVisible = () => (
    nav.classList.contains('dropdown-nav')
  );

  // const isOdd = num => (
  //   num % 2 === 1
  // );

  const getTotalListItemDims = (ul) => {
    const listItems = ul.querySelectorAll('button span');
    let height = 0;
    let width = 0;
    for (let i = 0; i < listItems.length; i++) { /* eslint-disable-line no-plusplus */
      height += listItems[i].offsetHeight;
      width += listItems[i].offsetWidth;
    }
    // if (wrapper.classList.contains('documents-dropdown')) {
    //   // get half the height of the whole list and round up to the next even number
    //   let offset = 0;
    //   if (isOdd(listItems.length)) {
    //     offset = (height / listItems.length);
    //   }
    //   height = (height / 2) + offset; /* eslint-disable-line prefer-destructuring */
    // }
    return {
      height: height + 3,
      width: width + ((listItems.length - 1) * 15),
    };
  };

  const toggleDropdownNav = () => {
    const isExpanded = dropdownBtn.getAttribute('aria-expanded') === 'true';
    dropdownBtn.setAttribute('aria-expanded', String(!isExpanded));
    if (isExpanded) {
      nav.style.height = `${btnHeight}px`;
      setTimeout(() => {
        tablist.style.visibility = 'hidden';
      }, 200);
    } else {
      tablist.removeAttribute('style');
      nav.classList.remove('focus');
      nav.style.height = `${getTotalListItemDims(tablist).height + btnHeight}px`;
    }
  };

  const setSelectedTab = (event) => {
    const selectedTabLabel = wrapper.querySelector('.selected-tab');
    selectedTabLabel.textContent = event.target.textContent;
    if (isDropdownVisible()) {
      toggleDropdownNav();
    }
  };

  const addDropdownFocus = () => {
    nav.classList.add('focus');
  };

  const removeDropdownFocus = () => {
    nav.classList.remove('focus');
  };

  const update = () => {
    const addDropdown = getTotalListItemDims(tablist).width >= wrapper.offsetWidth;
    const containsSelector = nav.classList.contains('dropdown-nav');
    if (addDropdown && !containsSelector) {
      dropdownBtn.setAttribute('aria-expanded', 'false');
      nav.classList.add('dropdown-nav');
      tablist.style.visibility = 'hidden';
    } else if (!addDropdown && containsSelector) {
      dropdownBtn.setAttribute('aria-expanded', 'false');
      nav.classList.remove('dropdown-nav');
      nav.removeAttribute('style');
      tablist.removeAttribute('style');
    }
  };

  dropdownBtn.addEventListener('click', toggleDropdownNav);
  dropdownBtn.addEventListener('focus', addDropdownFocus);
  dropdownBtn.addEventListener('blur', removeDropdownFocus);
  // Tabs
  const tabBtns = wrapper.querySelectorAll('[role="tablist"] button');
  [].map.call(tabBtns, (btn) => {
    btn.addEventListener('click', setSelectedTab);
  });
  window.addEventListener('resize', update);
  update();
};

const tabnav = () => {
  const tabWrappers = document.querySelectorAll('.tabbed-content-wrapper');
  [].map.call(tabWrappers, (tabWrapper) => {
    initTabnav(tabWrapper);
  });
};

export default tabnav;
/* eslint-enable no-console */
